import service from '@/store/services/sample-service';
import axios from 'axios';

const state = {
  sample_profile: {},
  sample_report: {},
  loading: false,
};

const mutations = {
  SET_SAMPLE_PROFILE: (state, payload) => {
    state.sample_profile = payload;
  },
  SET_SAMPLE_REPORT: (state, payload) => {
    state.sample_report = payload;
  },
  SET_LOADING: (state, payload) => {
    state.loading = payload;
  },
};

const actions = {
  getIFProfile({ commit, dispatch, state }) {
    return service
      .getIFProfile()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }

        commit('SET_SAMPLE_PROFILE', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getIMRProfile({ commit, dispatch, state }) {
    return service
      .getIMRProfile()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }             
       
        commit('SET_SAMPLE_PROFILE', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getCompanyProfile({ commit, dispatch, state }) {
    return service
      .getCompanyProfile()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
       
        commit('SET_SAMPLE_PROFILE', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getIFReport({ commit, dispatch, state }) {
    return service
      .getIFReport()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_SAMPLE_REPORT', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getIMRReport({ commit, dispatch, state }) {
    return service
      .getIMRReport()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_SAMPLE_REPORT', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getCompanyReport({ commit, dispatch, state }) {
    return service
      .getCompanyReport()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_SAMPLE_REPORT', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  getValuationReport({ commit, dispatch, state }) {
    return service
      .getValuationReport()
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_SAMPLE_REPORT', res);
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const getters = {
  sampleProfile: (state) => state.sample_profile,
  sampleReport: (state) => state.sample_report,
};

const user = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default user;
